import { InternalLink } from "@/components/InternalLink";
import { Popover } from "@/design-system/Popover/Popover";
import { Trans, useTranslation } from "@repo/shared/i18n";
import { EVOLUTION_STATES_GUIDE_PATH } from "@repo/shared/utils";
import { Info } from "lucide-react";

/** The states guide's lead line behind an info icon, linking to the guide. */
export const EvolutionStatesInfo = () => {
  const { t } = useTranslation(["evolutions", "common"]);
  return (
    // Stops here, after the popover's own toggle: the toolbar's panels close
    // on any click that reaches the document.
    <span className="flex" onClick={(e) => e.stopPropagation()}>
      <Popover
        placement="bottom"
        align="start"
        width={280}
        negLabel=""
        posLabel=""
        newDesignSystem
        title={t("statesGuide.title")}
        trigger={
          <button
            type="button"
            aria-label={t("statesGuide.title")}
            className="flex shrink-0 text-foreground-muted transition-colors hover:text-foreground"
          >
            <Info className="size-4" />
          </button>
        }
      >
        <p>
          <Trans
            ns="evolutions"
            i18nKey="statesGuide.lead"
            // Plain here: an explainer, not the guide's pitch.
            components={{ highlight: <span /> }}
          />
        </p>
        <span className="mt-3 inline-flex">
          <InternalLink to={EVOLUTION_STATES_GUIDE_PATH}>
            {t("common:learnMore")}
          </InternalLink>
        </span>
      </Popover>
    </span>
  );
};
